const PATIENT_PROFILE_QA_GOALS = {
  node_btn_close: 'patient_profile__node_btn_close', // Узел кнопки 'Закрыть'
  node_criterion: 'patient_profile__node_criterion', // Узел с критерием доверия к пациенту
  node_count_appointments: 'patient_profile__node_count_appointments', // Узел кол-ва записей
}

export default PATIENT_PROFILE_QA_GOALS
